// src/Svgs/IconLoading.tsx
import React from "react";
var IconLoading = /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.82917 3.32841C6.87969 2.86032 8.05339 2.74436 9.1752 2.99782C10.297 3.25128 11.3068 3.86058 12.0541 4.73485C12.8013 5.60912 13.2459 6.70151 13.3216 7.84911C13.3973 8.99671 13.1 10.138 12.474 11.1028C11.848 12.0677 10.9269 12.8043 9.84812 13.2028C8.7693 13.6014 7.59054 13.6406 6.48765 13.3145C5.38475 12.9884 4.41682 12.3145 3.72819 11.3934C3.03957 10.4722 2.66716 9.35317 2.6665 8.20307V7.65146C2.6665 7.28327 2.36803 6.98479 1.99984 6.98479C1.63165 6.98479 1.33317 7.28327 1.33317 7.65146V8.20345C1.33399 9.64107 1.79951 11.0403 2.66028 12.1917C3.52106 13.3432 4.73098 14.1855 6.1096 14.5931C7.48822 15.0007 8.96167 14.9518 10.3102 14.4536C11.6587 13.9553 12.8101 13.0346 13.5925 11.8285C14.375 10.6225 14.7466 9.19588 14.6521 7.76138C14.5575 6.32688 14.0017 4.96139 13.0677 3.86855C12.1336 2.77572 10.8713 2.01409 9.46905 1.69727C8.06678 1.38044 6.59966 1.5254 5.2865 2.11051C4.95019 2.26036 4.79903 2.65448 4.94888 2.99079C5.09874 3.32711 5.49285 3.47826 5.82917 3.32841Z",
      fill: "#81858C"
    }
  )
);
var IconLoading_default = IconLoading;
export {
  IconLoading_default as default
};
